import { api } from '../onboarding/api.ts';
import type { WorkspaceCredentials } from './types.ts';
import type {
  DiscoveryEligibility,
  DiscoveryProgressResponse,
  DiscoveryRecords,
  StartDiscoveryRequest,
} from './types.ts';

export const discoveryClient = {
  eligibility: (workspaceId: string, credentials: WorkspaceCredentials = {}) =>
    api.getDiscoveryEligibility(workspaceId, credentials.session, credentials.token),

  latestAttempt: (
    workspaceId: string,
    credentials: WorkspaceCredentials = {},
    withoutEvidence = false,
  ) =>
    api.getLatestDiscoveryAttempt(
      workspaceId,
      credentials.session,
      credentials.token,
      withoutEvidence,
    ),

  evidenceSince: (
    workspaceId: string,
    attemptId: string,
    since: number,
    credentials: WorkspaceCredentials = {},
  ) =>
    api.getDiscoveryEvidenceSince(
      workspaceId,
      attemptId,
      since,
      credentials.session,
      credentials.token,
    ),

  attempt: (workspaceId: string, attemptId: string, credentials: WorkspaceCredentials = {}) =>
    api.getDiscoveryAttempt(workspaceId, attemptId, credentials.session, credentials.token),

  records: (workspaceId: string, attemptId?: string, credentials: WorkspaceCredentials = {}) =>
    api.getDiscoveryRecords(workspaceId, attemptId, credentials.session, credentials.token),

  progress: (workspaceId: string, credentials: WorkspaceCredentials = {}) =>
    api.getDiscoveryProgress(workspaceId, credentials.session, credentials.token),

  findings: (
    workspaceId: string,
    credentials: WorkspaceCredentials = {},
    filters: { severity?: string; lane?: 'DNS' | 'Network' | 'Mixed' } = {},
  ) => api.getDiscoveryFindings(workspaceId, credentials.session, credentials.token, filters),

  finding: (workspaceId: string, findingId: string, credentials: WorkspaceCredentials = {}) =>
    api.getDiscoveryFinding(workspaceId, findingId, credentials.session, credentials.token),

  start: (
    workspaceId: string,
    input: StartDiscoveryRequest,
    idempotencyKey: string,
    credentials: WorkspaceCredentials = {},
  ) =>
    api.startDiscovery(workspaceId, input, idempotencyKey, credentials.session, credentials.token),

  stop: (workspaceId: string, credentials: WorkspaceCredentials = {}) =>
    api.stopDiscovery(workspaceId, credentials.session, credentials.token),
};

export type {
  DiscoveryEligibility,
  DiscoveryProgressResponse,
  DiscoveryRecords,
  StartDiscoveryRequest,
};
